module.exports = __webpack_public_path__ + "img/hug.e3be77fd.svg";